import axios from "axios";

const baseURL = `https://suggestions.dadata.ru/suggestions/api/4_1/rs`;
const token = "ba25fdde33b2faa3ad77c67dcc53308995c842d7";

const dataApi = axios.create({ baseURL });

dataApi.defaults.headers.common.Authorization = `Token ${token}`;

export default dataApi;
